import { useMemo } from 'react';
import { useDrafts } from '~/pages/DraftsDashboard/hooks/useDrafts';
export const useAgreementNameOptions = ()=>{
    const { drafts } = useDrafts();
    return useMemo(()=>{
        const seen = new Set();
        const options = [];
        for (const draft of drafts){
            const title = draft.title.trim();
            if (title.length === 0 || seen.has(title)) continue;
            seen.add(title);
            options.push({
                value: title,
                label: title
            });
        }
        return options.sort((a, b)=>a.label.localeCompare(b.label));
    }, [
        drafts
    ]);
};
